import {keys, union, transform, get} from 'lodash';

import {usePrevious} from 'hooks';

export function useIsChanged<T>(value: T, initialValue?: T) {
    const prevValue = usePrevious<T>(value, initialValue);
    return prevValue !== value;
}

export function useIsChangedTo<T>(value: T, to: any) {
    const prevValue = usePrevious<T>(value);
    return prevValue !== to && value === to;
}

type ObjectDiff = Record<string, {prev: any, current: any}>;
export function useObjectDiff<T extends Record<string, any>>(currentObject: T, initialObject?: T): ObjectDiff {
    const prevObject = usePrevious<T>(currentObject, initialObject);
    return transform(union(keys(currentObject), keys(prevObject)), ((diff: ObjectDiff, key: string) => {
        const currentValue = get(currentObject, [key]);
        const prevValue = get(prevObject, [key]);
        if (prevValue !== currentValue) {
            diff[key] = {
                prev: prevValue,
                current: currentValue
            };
        }
    }), {});
}